import { Routes, Route } from "react-router-dom";

import { OsciLpcoCfgnRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoCfgnRouter";
import { OsciLpcoComnRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoComnRouter";
import { OsciLpcoFeeRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoFeeRouter";
import { OsciHsCdRouter } from "@/tz/go/egaz/osci/lpco/router/OsciHsCdRouter";
import { OsciLpcoAprvRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoAprvRouter";
import { OsciInscRouter } from "@/tz/go/egaz/osci/lpco/router/OsciInscRouter";
import { OsciLpcoTansadRouter } from "@/tz/go/egaz/osci/lpco/router/OsciLpcoTansadRouter";
import { OSCI0206001Q } from "../prcss/OSCI0206001Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const OsciLpcoMainRouter = () => {
    return (
        <Routes>
            <Route path="/cfgn/*" element={<OsciLpcoCfgnRouter />} />
            <Route path="/fee/*" element={<OsciLpcoFeeRouter />} />
            <Route path="/hscd/*" element={<OsciHsCdRouter />} />
            <Route path="/insc/*" element={<OsciInscRouter />} />

            {/* 공통 화면 정의 (추가되는 화면은 해당 주석 위에 작업할 것) */}
            <Route path="/comn/ppup/*" element={<OsciLpcoComnRouter />} />
            <Route path="/app/*" element={<OsciLpcoAprvRouter />} />
            <Route path="/tansad/*" element={<OsciLpcoTansadRouter />} />
            <Route path="/prcss/osci0206001q" element={<OSCI0206001Q />} />
        </Routes>
    );
};
